import { UserButton } from '@clerk/clerk-react'
import { NavLink, Outlet } from 'react-router-dom'

const NAV = [
  { to: '/app/projects', label: 'Projects' },
  { to: '/app/settings', label: 'Settings' },
]

export function AppShell() {
  return (
    <div className="shell">
      <header className="shell__bar">
        <NavLink to="/app/projects" className="wordmark">
          detach<span>ly</span>
        </NavLink>
        <nav className="shell__nav" aria-label="Main">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} className="shell__link">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <UserButton afterSignOutUrl="/" />
      </header>
      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  )
}
